import React from 'react'
import { Link } from 'gatsby'
import s from './tabsCustomLinks.module.css'
import { GTMEvents } from '../../lib/GTMevents'

const TabsCustomLinks = props => {
  const onClick = tab => {
    if (props.customGTM === false) {
      GTMEvents.TypeContributionTabs(
        props.GTMSection,
        props.GTMTitle,
        tab.title,
        tab.hash
      )
    } else {
      props.event(tab.title)
    }
  }

  return (
    <div>
      <div
        id="GTM-MOD-MEP-SECTION-TP-TAB"
        className={`${s.container} ${props.className} tw-px-10@lg`}
      >
        <div className={`${s.tabs} brad-3 shadow`}>
          {props.data.map((tab, i) => (
            <div
              onClick={() => {
                onClick(tab)
              }}
            >
              <Link
                id="GTM-MOD-MEP-SECTION-TP-TAB-ITEM"
                className={`${s.tabBtn} ${
                  i === props.active ? s.tabBtnActive : ''
                } font-family-secondary fw-6 tw-f-14 tw-f-18@lg`}
                to={tab.hash}
                key={tab.title}
              >
                {tab.icon ? (
                  <tab.icon
                    fill={props.icoColor}
                    width={props.iconSize}
                    height={props.iconSize}
                  />
                ) : null}
                <span>{tab.title}</span>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

TabsCustomLinks.defaultProps = {
  title: '', // Titulo
  icon: '', // Icono
  icoColor: '#04A6A2', // Color del icono
  className: '', // Clase CSS
  iconSize: 24, // Size de icono
  data: [],
  customGTM: false,
  event: () => {}, //Se usa para mandar el GTM de eventos atm
}

export default TabsCustomLinks
